import { cn } from 'helpers/css';
import React from 'react';
import { Badge } from 'shadcn/components/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'shadcn/components/table';

/**
 *
 * @param {Object} props
 * @param {{ prop: string, type: string, default: string }[]} props.source
 * @param {string} props.className
 * @returns
 */
const Props = ({ source, className }) => {
  return (
    <div className={cn('component:Props default-border', className)}>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className='tw-font-semibold'>Prop</TableHead>
            <TableHead className='tw-font-semibold'>Type</TableHead>
            <TableHead className='tw-font-semibold'>Default</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {source.map((el) => {
            return (
              <TableRow key={el.prop}>
                <TableCell>
                  <div className='tw-inline-block tw-p-1 tw-px-2 tw-rounded-md dark:tw-text-[#6abaff] dark:tw-bg-[#132e4f] tw-text-[#0072dd] tw-bg-[#e6f4fe]'>
                    {el.prop}
                  </div>
                </TableCell>
                <TableCell>
                  <pre className='dark:tw-text-white tw-text-black tw-text-sm'>{el.type}</pre>
                </TableCell>
                <TableCell>
                  <Badge variant={'secondary'}>{el.default}</Badge>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default Props;
